import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'api/apiCommon'

import { type LookupTypes, type LookupItem } from './lookup.types'

interface LookupPayload {
  value: LookupTypes
  data: LookupItem[]
}
interface GetLookupPayload {
  value: LookupTypes
}

export const getLookup = createAsyncThunk(
  'vendor/getLookup',
  async (payload: GetLookupPayload): Promise<LookupPayload> => {
    return await new Promise((resolve, reject) => {
      axiosInstance
        .get<LookupItem[]>(`/processing/lookup?value=${payload.value}`)
        .then((res) => {
          resolve({ value: payload.value, data: res })
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  },
)
